import { ConversationParamSpec } from './conversationUrlState';

const uuid: ConversationParamSpec = {
  parse: raw =>
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(raw)
      ? raw.toLowerCase()
      : null,
};

export const transcriptUrlKeys = { thread: uuid, turn: uuid };
